import { render } from "./WizardSearch.vue?vue&type=template&id=0cd9b6cd&scoped=true"
import script from "./WizardSearch.vue?vue&type=script&lang=js"
export * from "./WizardSearch.vue?vue&type=script&lang=js"

import "./WizardSearch.vue?vue&type=style&index=0&id=0cd9b6cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd9b6cd"]])

export default __exports__